<template>
  <div class="home">
    <Item v-for="i in list" :key="i.title" v-bind="i" />
  </div>
</template>

<script>
function getUrlParams(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  // return null
  return "";
}
import Item from "./Item";
export default {
  name: "home",
  data() {
    return {
      list: [
        {
          imgSrc: require("../assets/hunan.png"),
          title: "湘通卡（湖南）",
          text: "",
          isAvaiale: true,
          noVideo: true,
          jumpParam: "xiangtong",
          hideInMini: true,
          beidou: true
        },
        {
          imgSrc: require("../assets/zhaoshang.png"),
          title: "招商畅行卡（西藏）",
          text: "",
          isAvaiale: true,
          noVideo: true,
          jumpParam: "xiangtong",
          hideInMini: true,
        },
        {
          imgSrc: require("../assets/gantong.png"),
          title: "赣通卡（江西）",
          text: "",
          isAvaiale: true,
          noVideo: true,
          jumpParam: "gantong",
        },
        {
          imgSrc: require("../assets/jitong.png"),
          title: "吉通卡（吉林）",
          text: "",
          isAvaiale: true,
          noVideo: true,
          jumpParam: "jitong",
        },
        {
          imgSrc: require("../assets/mintong.png"),
          title: "闽通卡（福建）",
          text: "",
          isAvaiale: true,
          jumpParam: "mintong",
        },
        {
          imgSrc: require("../assets/qiantong.jpg"),
          title: "黔通卡（贵州）",
          text: "",
          isAvaiale: true,
          jumpParam: "qiantong",
          beidou: true
        },
        {
          imgSrc: require("../assets/sutong.png"),
          title: "苏通卡(江苏)",
          text: "",
          isAvaiale: true,
          jumpParam: "xiangtong",
          hideInMini: true,
        },
        {
          imgSrc: require("../assets/yuetong.png"),
          title: "粤通卡(广东)",
          text: "",
          isAvaiale: true,
          jumpParam: "yuetong",
          noVideo: true,
        },
        {
          imgSrc: require("../assets/zhetong.png"),
          title: "浙江卡（浙江）",
          text: "",
          isAvaiale: true,
          jumpParam: "zhetong",
        },
      ],
    };
  },
  components: {
    Item,
  },
  created() {
    if (getUrlParams("fromMini")) {
      this.list = this.list.filter((i) => !i.hideInMini);
    }
    if (getUrlParams('source') === 'beidou') {
      this.list = this.list.filter(i => i.beidou)
    }
  },
  methods: {
    // 黔通卡
    // qiantong() {
    //   this.$router.push({ name: "about", params: { productName: "qiantong" } });
    // }
    // 苏通卡
    // shutong () {
    //   this.$router.push({name: 'about', params: {productName: 'shutong'}})
    // }
  },
};
</script>

<style lang="scss" scoped>
.home {
  background-color: #f5f5f5;
}
</style>
